module.exports = __webpack_public_path__ + "img/hand-coin-line.e4dc892a.png";